/**
 * Montagem de query string.
 *
 * Campo vazio, `null` e `undefined` NÃO viram parâmetro: `?status=` chegaria na
 * API como string vazia e reprovaria na validação Zod do enum — um filtro
 * limpo pela pessoa viraria erro 422 na tela.
 */
export type ValorDeQuery = string | number | boolean | null | undefined

export function montarQuery(parametros: Readonly<Record<string, ValorDeQuery>>): string {
  const busca = new URLSearchParams()

  for (const [chave, valor] of Object.entries(parametros)) {
    if (valor === null || valor === undefined) {
      continue
    }

    const texto = String(valor)

    if (texto.length === 0) {
      continue
    }

    busca.set(chave, texto)
  }

  const query = busca.toString()

  return query.length > 0 ? `?${query}` : ''
}
